import { type } from '@/utils/type'


export const LAYERMAP_DEPTH_PROFILE_REQUEST = type('LAYERMAP_DEPTH_PROFILE_REQUEST')
export const LAYERMAP_DEPTH_PROFILE_SUCCESS = type('LAYERMAP_DEPTH_PROFILE_SUCCESS')
export const LAYERMAP_DEPTH_PROFILE_ERROR = type('LAYERMAP_DEPTH_PROFILE_ERROR')

export const LAYERMAP_DEPTH_PROFILE_PROVIDER = type('LAYERMAP_DEPTH_PROFILE_PROVIDER')